import {IconButton} from '@logistics-frontend/blocks'
import {Image} from '@logistics-frontend/blocks/image'
import {tag2url} from '@logistics-frontend/utils'
import React, {memo} from 'react'

import {IconButtonWidgetConfig} from '../types'

export const IconButtonWidget = memo(
  ({accessibility_label, image: {image_tag}}: IconButtonWidgetConfig): React.ReactElement => (
    <IconButton size="m" title={accessibility_label} variant="ghost">
      <Image alt="" height={24} src={tag2url(image_tag)} />
    </IconButton>
  ),
)
